import React from 'react';
import resim_1 from '../assets/images/about/resim_1.jpg';
import resim_2 from '../assets/images/about/resim_2.jpg';
import piri_logo from '../assets/images/about/piri_logo.png';
import { FaCogs, FaMagic, FaBookOpen, FaClipboardList, FaLightbulb, FaPenFancy, FaEdit, FaSpellCheck, FaKey, FaSearch, FaFile, FaHighlighter, FaQuestionCircle, FaExpand, FaGlobe, FaLanguage, FaShareAlt, FaCloudDownload, FaChartLine, FaBrain } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';


const AboutPage = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;
   

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black bg-opacity-50"
                onClick={onClose}
            />

            {/* Modal Content */}
            <div className="relative bg-white w-[90vw] max-w-6xl max-h-[90vh] overflow-y-auto rounded-lg p-6 z-10">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                <div className="space-y-8">
                    {/* Hero Section */}
                    <div className="text-center mb-12">
                        <h1 className="text-3xl font-bold text-[#3c4f58] mb-4">{t('Piri AI: Akademik Araştırmalar için Üretken Yapay Zeka')}</h1>
                    </div>
                    

                    {/* Main Content Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* Left Column - Text Content */}
                        <div className="space-y-6">
                            <div>
                                <br></br><br></br>
                                <h2 className="text-2xl font-semibold text-[#3c4f58] mb-4">   {t('Geleceğin Akademik Araştırma Aracı')}</h2>
                                <p className=" text-justify text-gray-700">
                                {t('about5')}
                                     <br/><br/>
                                </p>
                                <p className="text-justify text-gray-700">
                                {t('about6')}
                                    

                                </p>
                            </div>
                        </div>
                        <img src={piri_logo} alt="Piri AI" className="w-75 rounded-lg"/>


                    </div>

                    {/* Features Section */}
                    <div className="space-y-12">
                        {/* Dinamik İçerik Üretimi */}
                        <div className="bg-gray-50 p-6 rounded-lg">
                            <h2 className="text-2xl font-semibold text-center text-[#3c4f58] mb-6 flex items-center justify-center">
                                <div className="mr-2 text-3xl text-[#3c4f58]"/>    {t('Dinamik İçerik Üretimi')}
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {[
                                    {
                                        icon: FaBookOpen,
                                          title: t('Kapsamlı Literatür Özeti'),
                                        description:
                                            t('Kaynaklarınızı tek bir yerde toplayarak önemli bilgileri kolayca sentezlemenizi sağlar.')

                                        },
                                    {
                                        icon: FaLightbulb,
                                        title: t('Yaratıcı Yazım Önerileri') ,
                                        description:
                                            t('Akademik metinlerinizi zenginleştirmek için bağlam odaklı öneriler sunar.')
                                    },
                                    {
                                        icon: FaEdit,
                                        title: t('Anlık Düzenleme'),
                                        description:
                                            t('İçeriğinizi üretirken dil bilgisi, stil ve ton açısından düzenlemeler yapar.')
                                    }
                                ].map(({icon: Icon, title, description}, idx) => (
                                    <div
                                        key={idx}
                                        className="p-4 bg-white rounded-lg shadow flex flex-col items-center hover:bg-gray-100 transition duration-300 group"
                                    >
                                        <Icon className="text-4xl text-[#3c4f58] mb-2"/>
                                        <h3 className="font-semibold text-lg mb-2 text-center">{title}</h3>
                                        <p className="text-gray-600 text-center hidden group-hover:block">{description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Özellikler */}
                        <div className="bg-gray-50 p-6 rounded-lg">
                            <h2 className="text-2xl font-semibold text-center text-[#3c4f58] mb-6 flex items-center justify-center">
                                <div className="mr-2 text-3xl text-[#3c4f58]"/> Özellikler
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {[
                                    {
                                        icon: FaKey,
                                        title: t('Akıllı Anahtar Kelime ve Alternatif Üretimi'),
                                        description:
                        
                                    t('Araştırma konularınızı zenginleştirmek ve odaklanmak istediğiniz alana yönlendirmek için anahtar kelimeler önerir.')
                                        },
                                    {
                                        icon: FaFile,
                                        title: t('Yayın Taraması ve İçerik Özeti'), 
                                        description:
                                            t('Akademik makaleleri tarar ve en önemli bilgileri özümsemenize yardımcı olacak özetler sağlar.')
                                    },
                                    {
                                        icon: FaQuestionCircle,
                                        title: t('Araştırma Genişletme ve Soru Önerileri'),
                                        description:
                                            t('Çalışmanızın kapsamını genişletmek için yaratıcı ve hedefe yönelik soru önerileri sunar')
                                    },
                                    {
                                        icon: FaGlobe,
                                        title: t('Çoklu Dil Desteği'),
                                        description:
                                            t('Çeşitli dillerde araştırma yapma ve içerik üretme imkânı tanıyarak küresel ölçekte bir bilgi ağına erişim sağlar')
                                    },
                                    {
                                        icon: FaShareAlt,
                                        title: t('Kolay Dışa Aktarım ve Paylaşım'),
                                        description: t('Ürettiklerinizin farklı formatlarda hızlı bir şekilde paylaşılmasını sağlar.')
                                    },
                                    {
                                        icon: FaChartLine,
                                        title: t('Kaynaklar Üzerinde Derinlemesine Analizt'),
                                        description: t('Çalışmalarınıza anlam katan kapsamlı kaynak analizleri sunar')
                                    }
                                ].map(({icon: Icon, title, description}, idx) => (
                                    <div
                                        key={idx}
                                        className="p-4 bg-white rounded-lg shadow flex flex-col items-center hover:bg-gray-100 transition duration-300 group"
                                    >
                                        <Icon className="text-4xl text-[#3c4f58] mb-2"/>
                                        <h3 className="font-semibold text-lg mb-2 text-center">{title}</h3>
                                        <p className="text-gray-600 text-center hidden group-hover:block">{description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Contact Section */}
                    <div className="text-center bg-[#3c4f58] text-white p-8 rounded-lg">
                        <h2 className="text-2xl font-semibold mb-4"> {t('İletişim ve Abonelik Bilgileri')} </h2>
                        <p className="mb-4">
                            {t('about2')}
                        </p>
                        <div className="flex justify-center space-x-8">
                            <div>
                                <p className="font-semibold">{t('Email')}</p>
                                <p>info@kesifaraci.com</p>
                            </div>
                            <div>
                                <p className="font-semibold">{t('Telefon')}</p>
                                <p>+90 531 652 27 42</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;